/**
 * Plan overlap of two outlines — a detector, kept out of `geometry.js` so the
 * modules that only need points and distances (the estimate's
 * `labor/splitFamilies.js` among them) do not load a polygon clipper.
 *
 * Pure. X-Z plane.
 */

const polygonClipping = require('polygon-clipping');
const { signedAreaXZ } = require('../geometry/polygonSplit');
const { withSnapRetry } = require('../geometry/clipRetry');

/**
 * Plan area two `{x,z}` rings share, 0 when the clipper cannot answer. A
 * DETECTOR for "which one is this mostly over" — never a way to build a piece
 * (the clipper re-rounds; the cut keeps exact vertices, chainCut.js).
 */
function planOverlapArea(a, b) {
  if (!(a?.length >= 3) || !(b?.length >= 3)) return 0;
  // Two outlines that share an edge to a hair — a ceiling facet and the room
  // piece it lies over — are what the clipper refuses; on a grid it answers.
  const run = withSnapRetry(
    (snap) => {
      const toRing = (poly) => poly.map((p) => [snap(p.x), snap(p.z)]);
      return polygonClipping.intersection([toRing(a)], [toRing(b)]);
    },
    { exactFirst: true }
  );
  if (!run) return 0;
  const out = run.value;
  let area = 0;
  for (const poly of out) {
    poly.forEach((r, k) => {
      const ra = Math.abs(signedAreaXZ(r.map(([x, z]) => ({ x, z }))));
      area += k === 0 ? ra : -ra;
    });
  }
  return area;
}

module.exports = { planOverlapArea };
